<script lang="ts">
  export let title: string = '';

  export let location: { x: number; y: number };

  export let arrow:
    | 'left'
    | 'right'
    | 'top'
    | 'bottom'
    | 'top-left'
    | 'top-right'
    | 'bottom-left'
    | 'bottom-right' = 'left';

  let top: number = location?.y;
  let left: number = location?.x;

  let element: HTMLDivElement;

  $: {
    if (element) {
      const { width, height } = element.getBoundingClientRect();

      switch (arrow) {
        case 'bottom':
          left = location.x - width / 2;
          top = location.y - height - 10;
          break;
        case 'top':
          left = location.x - width / 2;
          top = location.y + 10;
          break;
        case 'left':
          left = location.x + 10;
          top = location.y - height / 2;
          break;
        case 'right':
          left = location.x - width - 10;
          top = location.y - height / 2;
          break;
        default:
          break;
      }
    }
  }
</script>

<div
  role="button"
  tabindex="0"
  class="absolute flex flex-row items-center justify-center ease-in-out duration-300 transition-all z-[20]"
  style="top: {top}px; left: {left}px;"
  bind:this={element}
  on:mouseover
  on:mouseleave
  on:focus
>
  <div
    class="tip absolute bg-grey-transparency-dark-80 backdrop-blur-[4px] w-4 h-4 rotate-45 rounded-md ease-in-out duration-300"
    class:-top-1.5={arrow === 'top'}
    class:-bottom-1.5={arrow === 'bottom'}
    class:-left-1.5={arrow === 'left'}
    class:-right-1.5={arrow === 'right'}
  />

  <div
    class="h-full rounded-14 backdrop-blur-[4px] bg-grey-transparency-dark-80 p-2 text-white font-normal ease-in-out duration-300"
  >
    <slot>
      {title}
    </slot>
  </div>
</div>
